<script setup lang="ts" generic="T extends TVariant">
import { type Component, defineAsyncComponent } from 'vue'
import type { IInputFieldEvents, IInputFieldProps, TVariant } from './types'
import { pascalCase } from '@/lib/utils'

defineOptions({
    inheritAttrs: false,
})

const props = defineProps<IInputFieldProps<T>>()
const emit = defineEmits<IInputFieldEvents>()

const components = import.meta.glob('./components/*.vue')
let variantComponent: Component | null = null

if (props.variant) {
    variantComponent = defineAsyncComponent(async (): Promise<any> => {
        const componentName = `V${pascalCase(props.variant)}Input.vue`
        const path = `./components/${componentName}`

        if (path in components) {
            return await components[path]()
        }

        throw new Error(`Component ${path} not found`)
    })
} else {
    console.error('Variant is undefined')
}
</script>

<template>
    <component
        :is="variantComponent"
        v-bind="props"
        data-gpp-tools-ui
        @update:model-value="emit('update:modelValue', $event)"
        @clear="emit('clear')"
        @dropdown="emit('dropdown')"
        @blur="emit('blur')"
        @focus="emit('focus')"
    />
</template>
